import styles from 'styles/privacyPolicy.module.css';
import { TopBar } from 'components/store/TopBar';
import PropTypes from 'prop-types';
import {
  backButtonIconDesktop,
} from 'components/utils/icon';
import {
  useIsDesktop
} from 'contexts/profile';
import { Clickable } from 'phoenix-components';
import { useRouter } from 'next/router';
import DisablePopup from 'components/store/common/DisablePopup';
import { useTrackGa } from 'hooks/ga';

export default function Terms({ shop }) {

  // const text = '/images/footer/windoText.svg';
  // const logo = '/images/footer/windo.svg';
  const isDesktop = useIsDesktop();
  const router = useRouter();
  const { legalTncs = '' } = shop;
  const isEmmpty = legalTncs?.trim()?.length === 0;
  useTrackGa(shop._id, 'terms', shop._id);

  return (
    <div className={styles.container}>
      <DisablePopup blocked={shop?.blocked} />
      <TopBar shop={shop} showTabs={false} />
      {isDesktop && (<Clickable onClick={router.back} className={styles.iconCon}>
        {backButtonIconDesktop()}
        <span className={styles.back}> Back </span>
      </Clickable>)}
      <div className={styles.section}>
        <div className={styles.head}>
          Terms & Conditions
        </div>
        {isEmmpty ? (
          <div className={styles.empty}>
            This shop has not set any Terms & Conditions.
          </div>
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: shop?.legalTncs }}
            className={styles.tile2}>
          </div>
        )}
      </div>
      {/* <div className={styles.fixed}>*/}
      {/*  <div className={styles.flex}>*/}
      {/*    <div className={styles.powered}> Powered by </div>*/}
      {/*    <img className={styles.landingPageLogo} src={logo} alt="" />*/}
      {/*    <img className={styles.textLogo} src={text} alt="" />*/}
      {/*  </div>*/}
      {/*  <div className={styles.termsAndPolicy}>*/}
      {/*    <Clickable*/}
      {/*      onClick={() => {*/}
      {/*        window.open('https://www.getwindo.shop/privacy-policy', '_blank');*/}
      {/*      }}*/}
      {/*      className={styles.link}>*/}
      {/*      Privacy Policy */}
      {/*    </Clickable>*/}
      {/*    <div className={styles.seperator}> - </div>*/}
      {/*    <Clickable*/}
      {/*      onClick={() => {*/}
      {/*        window.open('https://www.getwindo.shop/terms-and-conditions', '_blank')*/}
      {/*      }}*/}
      {/*      className={styles.link}>*/}
      {/*    Terms & Conditions */}
      {/*    </Clickable>*/}
      {/*  </div>*/}
      {/* </div>*/}
    </div>
  );
}

Terms.defaultProps = {};

Terms.propTypes = {
  shop: PropTypes.object.isRequired,
};
